import { Component, OnInit } from '@angular/core';
import { ModalCategTrabajoInvitadoService } from './modal-categ-trabajo-invitado.service';
import { CategoriaTrabajoInvitadoService } from '../../services/services.index';
import { CategoriaTrabajo } from '../../models/categoriaTrabajo.model';

declare var swal: any;

declare var $;

@Component({
  selector: 'app-modal-categ-trabajo-invitado',
  templateUrl: './modal-categ-trabajo-invitado.component.html',
  styles: []
})
export class ModalCategTrabajoInvitadoComponent implements OnInit {

  parent: string;
  tipoCategoriaTrabajo: any;

  constructor(public _modalCategTrabajoService: ModalCategTrabajoInvitadoService,
              public _categoriaTrabajoService: CategoriaTrabajoInvitadoService) { }

              ngOnInit() {
                this._modalCategTrabajoService.cargarCategorias();
                this._modalCategTrabajoService.notification_show_modal.subscribe((categoria: CategoriaTrabajo) => {
                  // Cuando se abre el modal, recibo la categoria del modal. Despues asigno padre si lo tiene.
                  if (categoria.parent) {
                    this.parent = categoria.parent;
                  } else {
                    this.parent = '';
                  }
                });
              }

              guardarCategoria( form: any ) {
                // Antes de guardar pregunto si hay padre seleccionado y asigno o no en consecuencia.
                if (this.parent.length > 0) {
                  this._modalCategTrabajoService.categoria.parent = this.parent;
                } else {
                  this._modalCategTrabajoService.categoria.parent = undefined;
                }
                // Guardo cambios
                this._categoriaTrabajoService.guardarCategoriaTrabajo(this._modalCategTrabajoService.categoria).subscribe((resp: any) => {
                  this._modalCategTrabajoService.hideModal();
                  swal('Categoría Guardada', 'La categoría ' + resp.nombre_es + ' ah sido actualizada correctamente.', 'success');
                  this._modalCategTrabajoService.notification.emit(resp);
                  this._modalCategTrabajoService.cargarCategorias();
                });
              }

              borrarCategoria() {
                this._modalCategTrabajoService.hideModal2();
                swal({
                  title: '¿Esta seguro?',
                  text: '¿Esta seguro que desea borrar esta categoría?',
                  icon: 'warning',
                  buttons: true,
                  dangerMode: true,
                })
                .then((willDelete) => {
                  if (willDelete) {
                    this._categoriaTrabajoService.borrarCategoria(this._modalCategTrabajoService.categoria).subscribe(resp => {
                      swal('Categoria borrada', 'Categoria borrada satisfactoriamente.', 'success');
                      this._modalCategTrabajoService.cargarCategorias();
                      this._modalCategTrabajoService.hideModal();
                    });
                  }
                });
              }

              validarTipoCategoriaTrabajo() {

              }

}



// WEBPACK FOOTER //
// ./src/app/components/modal-categ-trabajo-invitado/modal-categ-trabajo-invitado.component.ts